import axios from "axios";
import getConfigByName from "../../../config";

const config = getConfigByName();

// Promotion banners for Tradersroom in the client's language, from Admin Panel > Promo Material > Promotion.
export async function getPromotions() {
    try {
        const response = await axios.get(`${config?.backendURL}api/promo-material/promotion`, {
            params: {language: localStorage?.getItem("language") || "en", placement: "TRADERSROOM"},
        });
        return response?.data;
    } catch (e) {
        console.error(e)
        throw e;
    }
}
